// extracted by mini-css-extract-plugin
module.exports = {"particles":"particle-effect_particles_f44Xs","wrapper":"particle-effect_wrapper_1inTV","content":"particle-effect_content_1AZ--","canvas":"particle-effect_canvas_3rwFa"};